// extracted by mini-css-extract-plugin
export default {"placemark":"BXII6"};